import { defineAsyncComponent } from 'vue';

export * from './stores/selfServiceForm';
export * from './constants';

export const selfServiceMicroFrontends = {
	SelfServiceSidebar: defineAsyncComponent(
		() => import('./components/SelfServiceSidebar')
	),
	SelfServicePage: defineAsyncComponent(
		() => import('./components/SelfServicePage')
	),
};
